export interface Coordinate {
  x: number;
  y: number;
}

export interface Position {
  left: number;
  top: number;
}

export type Move = 'up' | 'down' | 'right' | 'left';

export enum FloorTypes {
  FREE = 0,
  WALL = 1,
  DOOR = 2,
  BENCH = 3,

  SIGN = 8,
};
